// type: 'team' = top-level team boolean, 'feature' = displayable_features key, 'team_settings' = team_settings sub-document
export const TOGGLE_FIELDS = [
    // Tracking
    {
        id: 'google_news_tracking', section: 'tracking',
        label: 'Google News tracking',
        description: 'Monitors Google RSS feeds to surface news articles as candidates for prospects.',
        type: 'team', key: 'google_news_tracking',
        access: 'enable_tracking_fields',
    },
    {
        id: 'nlp_enabled', section: 'tracking',
        label: 'NLP analysis',
        description: "Uses natural language processing to detect and merge similar articles that fall below the confidence threshold.",
        type: 'team', key: 'nlp_enabled',
        access: 'enable_tracking_fields',
    },

    // Data sources
    {
        id: 'newsfeed_enabled', section: 'data_sources', source: 'news',
        label: 'News results',
        description: "News articles that mention this team's prospects",
        type: 'team', key: 'newsfeed_enabled',
    },
    {
        id: 'enable_job_updates_in_feed', section: 'data_sources', source: 'jobs',
        label: 'Job updates',
        description: 'Role and company changes for this team\'s prospects',
        type: 'team', key: 'enable_job_updates_in_feed',
        access: 'enable_job_updates',
    },
    {
        id: 'display_job_updates', section: 'data_sources', source: 'jobs',
        label: 'Job updates 2.0 in newsfeed',
        description: "Uses natural language processing to detect and merge similar articles that fall below the confidence threshold",
        type: 'feature', key: 'display_job_updates',
    },

    // SEC filings
    {
        id: 'sec_filings_enabled', section: 'data_sources', source: 'sec',
        label: 'SEC filings',
        type: 'team', key: 'sec_filings_enabled',
    },
    {
        id: 'sec_filings_premium', section: 'data_sources', source: 'sec',
        label: 'Premium',
        type: 'team', key: 'sec_filings_premium',
        parentKey: 'sec_filings_enabled',
        offWithParent: true,
    },
    {
        id: 'display_mid_confidence', section: 'data_sources', source: 'news',
        label: 'Mid confidence results',
        description: "Show results with a mid-level confidence score in the newsfeed",
        type: 'feature', key: 'display_mid_confidence',
        access: 'enable_mid_confidence',
    },

    // Directory
    {
        id: 'display_mapper_suggestions', section: 'directory',
        label: 'Mapper suggestions',
        description: "Enables algorithm-generated LinkedIn mapping suggestions for prospects",
        type: 'feature', key: 'display_mapper_suggestions',
    },
    {
        id: 'display_new_directory', section: 'directory',
        label: 'Directory and reports access for users',
        description: 'Display the Directory and Reports tab in the navigation header for normal users',
        type: 'feature', key: 'display_new_directory',
    },
    {
        id: 'display_ai_reports', section: 'directory',
        label: 'AI reports access for users',
        description: 'Allow normal users to create and use AI-powered reports',
        type: 'feature', key: 'display_ai_reports',
        parentKey: 'display_new_directory',
    },
    {
        id: 'display_directory_download', section: 'directory',
        label: 'Allow team admins to download from directory',
        description: 'Permit admins to export data directly from the Directory',
        type: 'feature', key: 'display_directory_download',
        access: 'enable_job_updates',
        parentKey: 'display_new_directory',
    },
    {
        id: 'display_only_mapped_data', section: 'directory',
        label: 'Show only mapped data to normal users',
        description: "Restrict normal users to only see mapped prospects",
        type: 'feature', key: 'display_only_mapped_data',
        access: 'enable_job_updates',
        parentKey: 'display_new_directory',
    },

    // Export
    {
        id: 'display_linkedin_url_in_export', section: 'export',
        label: 'Include LinkedIn URL in newsfeed & prospect exports',
        description: 'Append LinkedIn profile URLs when exporting newsfeed or prospect data',
        type: 'feature', key: 'display_linkedin_url_in_export',
        access: 'enable_job_updates',
    },
    {
        id: 'ln_url_in_directory_export', section: 'export',
        label: 'Include LinkedIn URL in Directory export',
        description: 'Append LinkedIn profile URLs when exporting directory data',
        type: 'feature', key: 'ln_url_in_directory_export',
        access: 'enable_job_updates',
    },
    {
        id: 'display_external_id', section: 'export',
        label: 'Show Unique ID in Email',
        description: "Display the prospect's unique ID in all post emails",
        type: 'feature', key: 'display_external_id',
    },

    // CRM
    {
        id: 'display_save_news_in_crm', section: 'crm',
        label: 'Save News Results to CRM',
        description: 'Push matched news results to the CRM for tracked prospects',
        type: 'feature', key: 'display_save_news_in_crm',
    },
    {
        id: 'display_save_jobs_in_crm', section: 'crm',
        label: 'Save Job Updates to CRM',
        description: 'Push job change updates to the CRM for tracked prospects',
        type: 'feature', key: 'display_save_jobs_in_crm',
    },

    // Identity / Security
    {
        id: 'two_fa_enabled', section: 'security',
        label: 'Two-Factor authentication',
        description: 'Require all team members to verify identity with a second factor on login',
        type: 'team_settings', key: 'two_fa_enabled',
    },
]

export const SECTIONS = [
    { key: 'tracking', label: 'Tracking' },
    { key: 'data_sources', label: 'Data sources' },
    { key: 'directory', label: 'Directory' },
    { key: 'export', label: 'Export & Identity' },
    { key: 'crm', label: 'CRM' },
    { key: 'security', label: 'Security' },
]

export const getFieldsBySection = (sectionKey, isFieldVisible) =>
    TOGGLE_FIELDS.filter(field => field.section === sectionKey && isFieldVisible(field))

export const getFieldById = fieldId =>
    TOGGLE_FIELDS.find(field => field.id === fieldId)
